import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BaseModalComponent } from "@ha/ui/common";
import { TranslocoService } from "@ngneat/transloco";
import { Store } from "@ngxs/store";
import { UserStateActions } from "apps/app/src/app/user/state/user.actions";
import { AuthSelectors } from "libs/feature/auth/src/lib/states/auth.selectors";
import { MfaActions } from "../../states/mfa.actions";

@Component({
    selector: "ha-disable-mfa-modal",
    templateUrl: "./disable-mfa-modal.component.html",
    styleUrls: ["./disable-mfa-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisableMfaModalComponent extends BaseModalComponent {
    public form = this.fb.group({
        verificationCode: ["", [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });

    public error: string | null = null;

    public readonly DisableAction = MfaActions.Disable;

    public constructor(
        private readonly fb: FormBuilder,
        private readonly store: Store,
        private readonly transloco: TranslocoService,
        private readonly cdr: ChangeDetectorRef,
    ) {
        super();
    }

    public hyphenate(text: string): string {
        if (!text) {
            return "";
        }

        return text.replace(/Tvåfaktorsautentisering/g, "Tvåfaktors&shy;autentisering").replace(
            /tvåfaktorsautentisering/g,
            "tvåfaktors&shy;autentisering",
        ).replace(/Tvåfaktorautentisering/g, "Tvåfaktor&shy;autentisering").replace(
            /tvåfaktorautentisering/g,
            "tvåfaktor&shy;autentisering",
        );
    }

    public mobileDisableLabel(): string {
        const full = this.transloco.translate("global.mfa.disableMfa");
        return full?.split(" ")[0] || full || "";
    }

    public confirm(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.error = null;
        const code = this.form.value.verificationCode!;
        const currentAccount = this.store.selectSnapshot(AuthSelectors.currentAccount);

        this.store.dispatch(new MfaActions.Disable(currentAccount?.identityUserId, code)).subscribe({
            next: () => {
                // Success - both verify and disable succeeded
                this.store.dispatch(new UserStateActions.GetUser());
                this.closeModal();
            },
            error: (err) => {
                // Error - either verification failed or disable failed
                const errorCode = err?.errorCode || err?.error?.errorCode;
                this.error = errorCode ? `errors.${errorCode}` : "errors.UNKNOWN";
                this.form.controls.verificationCode.setErrors({ invalid: true });
                this.cdr.markForCheck();
            },
        });
    }

    public resetError(event: Event): void {
        event.preventDefault();
        this.error = null;
        this.cdr.markForCheck();
    }
}
